export const testDashboarRoutes = {
	testDashboard: '/home/test-dashboard/:testID',
	testDashboardStudent: '/home/test-dashboard/:testID/subject/:subjectType/:subjectID/student/:studentID',
	testDashboardClass: '/home/test-dashboard/:testID/subject/:subjectType/:subjectID/class/:classID',
	testDashboardGroup: '/home/test-dashboard/:testID/subject/:subjectType/:subjectID/group/:groupID',
};
